var _style, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 100,
    viewBox: "0 0 300 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .text {\n      font-family: 'Segoe UI', sans-serif;\n      font-weight: bold;\n    }\n    .adv {\n      fill: #00aaff;\n      font-size: 40px;\n    }\n    .global {\n      fill: #00aaff;\n      font-size: 20px;\n    }\n    .globe {\n      fill: none;\n      stroke: #00aaff;\n      stroke-width: 2;\n    }\n  ")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 55,
    className: "text adv"
  }, "ADV")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 55,
    className: "text global"
  }, "Global")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2ba7999be25c5bd4929ac13baff1f30f.svg";
export { ForwardRef as ReactComponent };